import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import MLDialog from '../../MLDialog/MLDialog';
import AssignmentHeaderLabelAndTool from '../../AssignmentHeaderLabelAndTool';
import { round } from '../../../utils/util';

import s from './GradebookCommentDialog.module.css';

const MOBILE_WIDTH = 768;
const ANIMATION_DURATION = 300;

function formatGrade(grade, toFixedAmount) {
  const formatted = parseFloat(grade);
  if (isNaN(formatted)) {
    return round(parseFloat(0), toFixedAmount);
  }
  return round(formatted, toFixedAmount);
}

const GradebookCommentDialog = ({
  onClose,
  show,
  gradeCommentData,
  getLaunchUrl,
  handleLocalLaunch,
  disableEnforceFocus,
}) => {
  const [isHiding, setIsHiding] = useState(false);

  const originalGrade = formatGrade(gradeCommentData.grade, 2);
  const assignedPoints = formatGrade(gradeCommentData.assignedPoints, 0);
  const { course, percentGrade, isDropped } = gradeCommentData;
  const animateHideClass = isHiding ? s.hide : '';

  return (
    <Media query={{ maxWidth: MOBILE_WIDTH }}>
      {(matches) => (
        <MLDialog
          overlayClassName={s.overlay}
          bodyClassName={s.dialogBody}
          className={`${s.modalWindow} ${animateHideClass}`}
          title="Instructor Feedback"
          show={show}
          onClose={() => {
            if (!matches) return onClose();

            setIsHiding(true);
            setTimeout(() => {
              onClose();
            }, ANIMATION_DURATION);
          }}
          disableEnforceFocus={disableEnforceFocus}
        >
          <div className={s.showMobile}>
            <AssignmentHeaderLabelAndTool
              course={course}
              assignment={gradeCommentData}
              getLaunchUrl={getLaunchUrl}
              handleLocalLaunch={handleLocalLaunch}
            />
          </div>
          <div className={`${s.top}`}>
            <div className={s.leftTop}>
              <div className={`${s.headerText} ${s.gradeHeader}`}>Grade:</div>
              <div className={`${s.topGrade}`}>{percentGrade}</div>
              <div className={s.content}>
                {`${originalGrade}/${assignedPoints} pts.`}
              </div>
              {isDropped && <span className={s.dropped}>Dropped</span>}
            </div>
          </div>
          <div>
            <div className={`${s.headerText} ${s.hideMobile}`}>
              Note from Instructor
            </div>
            <p className={s.comment}>{gradeCommentData.comment}</p>
          </div>
        </MLDialog>
      )}
    </Media>
  );
};

GradebookCommentDialog.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  gradeCommentData: PropTypes.object,
  getLaunchUrl: PropTypes.func,
  handleLocalLaunch: PropTypes.func,
  disableEnforceFocus: PropTypes.bool,
};

export default GradebookCommentDialog;
